import React, {useEffect, useRef, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import "../assets/css/GameDetail.css"
import {MINIO_URL} from "../config"

function Card({title, children, scroll}) {
    return (
        <div className={`card ${scroll ? "card--scroll" : ""}`}>
            {title && (
                <div className="card__head">
                    <h3>{title}</h3>
                </div>
            )}
            <div className="card__body">{children}</div>
        </div>
    );
}

function Screenshots({items = []}) {
    const scrollRef = useRef(null);
    const [showLeftArrow] = useState(true);
    const [showRightArrow] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            const scrollAmount = 300;
            const newScrollLeft = scrollRef.current.scrollLeft + (direction * scrollAmount);
            scrollRef.current.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });
        }
    };

    const openFullscreen = (src) => {
        setSelectedImage(src);
    };

    const closeFullscreen = () => {
        setSelectedImage(null);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            closeFullscreen();
        }
    };

    // Close modal when clicking outside the image
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            closeFullscreen();
        }
    };

    return (
        <>
            <div style={{
                position: 'relative',
                width: '100%'
            }}>
                {showLeftArrow && (
                    <button
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '8px',
                            transform: 'translateY(-50%)',
                            background: 'rgba(255, 255, 255, 0.9)',
                            border: '1px solid #e6edf3',
                            borderRadius: '50%',
                            width: '36px',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#475569',
                            zIndex: 2,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                        }}
                        onClick={() => scroll(-1)}
                        aria-label="Previous"
                    >
                        ›
                    </button>
                )}

                <div
                    ref={scrollRef}
                    style={{
                        display: 'flex',
                        gap: '12px',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        scrollBehavior: 'smooth',
                        padding: '8px 4px',
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#c7d2fe transparent'
                    }}
                >
                    {items.map((src, i) => {
                        const isVideo = /\.mp4($|\?)/i.test(src);
                        return isVideo ? (
                            <video
                                key={src + i}
                                src={src}
                                style={{
                                    maxWidth: '500px',
                                    maxHeight: '300px',
                                    objectFit: 'cover',
                                    borderRadius: '8px',
                                    flexShrink: 0,
                                    border: '1px solid #e6edf3',
                                    background: '#f8fafc',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                    cursor: 'pointer'
                                }}
                                playsInline
                                muted
                                controls
                                preload="metadata"
                                onClick={() => openFullscreen(src)}
                            />
                        ) : (
                            <img
                                key={src + i}
                                src={src}
                                alt={`Screenshot ${i + 1}`}
                                loading="lazy"
                                style={{
                                    maxWidth: '500px',
                                    maxHeight: '300px',
                                    objectFit: 'cover',
                                    borderRadius: '8px',
                                    flexShrink: 0,
                                    border: '1px solid #e6edf3',
                                    background: '#f8fafc',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                    cursor: 'pointer'
                                }}
                                onClick={() => openFullscreen(src)}
                            />
                        );
                    })}
                </div>

                {showRightArrow && (
                    <button
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '8px',
                            transform: 'translateY(-50%)',
                            background: 'rgba(255, 255, 255, 0.9)',
                            border: '1px solid #e6edf3',
                            borderRadius: '50%',
                            width: '36px',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#475569',
                            zIndex: 2,
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                        }}
                        onClick={() => scroll(1)}
                        aria-label="Next"
                    >
                        ‹
                    </button>
                )}
            </div>

            {/* Fullscreen Modal */}
            {selectedImage && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.95)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                        padding: '20px'
                    }}
                    onClick={handleBackdropClick}
                    onKeyDown={handleKeyDown}
                    tabIndex={0}
                >
                    {/* Close Button */}
                    <button
                        style={{
                            position: 'absolute',
                            top: '20px',
                            right: '20px',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: 'none',
                            borderRadius: '50%',
                            width: '50px',
                            height: '50px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            fontSize: '24px',
                            color: 'white',
                            zIndex: 1001,
                            transition: 'all 0.2s ease',
                            backdropFilter: 'blur(10px)'
                        }}
                        onClick={closeFullscreen}
                        aria-label="Close"
                    >
                        ✕
                    </button>

                    {/* Media Content */}
                    <div
                        style={{
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        {selectedImage.endsWith('.mp4') ? (
                            <video
                                src={selectedImage}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                    borderRadius: '8px'
                                }}
                                controls
                                autoPlay
                                muted
                                playsInline
                            />
                        ) : (
                            <img
                                src={selectedImage}
                                alt="Fullscreen view"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                    borderRadius: '8px',
                                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
                                }}
                            />
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default function GameDetail({game}) {
    const navigate = useNavigate();
    useEffect(() => {
        const script = document.createElement('script');

        script.innerText = `document.querySelector('.description-text').innerHTML='${game.description}'`;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, [game]);

    const snapshots = (game) => {
        return game && game.snapshots ? <Screenshots
                items={game.screencshots.split(',').map((snapshot) => `${MINIO_URL}${game.id}/${snapshot}`)}/> :
            <p>تصویری موجود نیست.</p>

    }


    return (
        <>
            <section className="container section">
                <div className="crumbs">
                    <Link to="/games">بازی‌ها</Link>
                    <span>/</span>
                    <span>{game.category}</span>
                    <span>/</span>
                    <span className="current">{game.title}</span>
                </div>

                <div className="detail-grid">
                    <div className="appbox card">
                        <div className="appbox__meta">
                            <h1 className="appbox__title">{game.title}</h1>
                            <div className="appbox__dev">{game.category}</div>
                            <div className="chips chips--meta">
                                    <span className="chip">
                                       بروزرسانی: {game.last_update}
                                    </span>
                                <span className="chip">حجم: {game.volume}</span>
                                <span className="chip">{game.category}</span>
                                <span className="chip">
                                        امتیاز: ★ {game.rating}{game.votes ? ` · ${game.votes}` : ''}
                                    </span>
                            </div>
                            <div className="appbox__actions">
                                <div>
                                    <p>اگه قبلا نسخه نداشتی</p>
                                    <button
                                        className="download-lg"
                                        onClick={() => {
                                            const link = document.createElement("a");
                                            link.href = `${MINIO_URL}${game.id}/${game.latin_name}.apk`;
                                            link.download = `${game.game?.id || game.latin_name}.apk`;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }}
                                    >
                                        دانلود
                                    </button>
                                </div>
                                <div>
                                    <p>اگه نسخه قبلی رو نصب داری</p>
                                    <button
                                        className="download-lg"
                                        onClick={() => {
                                            const link = document.createElement("a");
                                            link.href = `${MINIO_URL}${game.id}/${game.latin_name}.apk`;
                                            link.download = `${game.game?.id || game.latin_name}.apk`;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }}
                                    >
                                        بروزرسانی
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="appbox__head">
                            <img
                                className="appbox__icon"
                                src={`${MINIO_URL}${game.id}/${game.image}`}
                                alt="icon"
                            />
                        </div>

                    </div>
                    <Card title="تصاویر برنامه">
                        <Screenshots
                            items={[
                                `${MINIO_URL}${game.id}/0.mp4`,
                                `${MINIO_URL}${game.id}/1.webp`,
                                `${MINIO_URL}${game.id}/2.webp`,
                                `${MINIO_URL}${game.id}/3.webp`,
                                `${MINIO_URL}${game.id}/4.webp`,
                                `${MINIO_URL}${game.id}/5.webp`,
                            ]}
                        />
                    </Card>

                    <div className="col col--left">
                        <Card title="" scroll>
                            <div className="description-text"></div>
                            <div>تاریخ بروزرسانی</div>
                            <div>{game.last_update}</div>
                        </Card>
                    </div>
                </div>

                <div className="detail__foot">
                    <button className="btn" onClick={() => navigate(-1)}>
                        بازگشت
                    </button>
                </div>
            </section>
        </>
    );
}